import React, { PureComponent } from 'react';
import { ShareButtonProps } from './shared';

/**
 * 分享按钮
 */
export class ShareButton extends PureComponent<ShareButtonProps> {
  render() {
    return null;
  }
}
